// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Jn8I6","buttonsLeft":"Header_buttonsLeft__O25LK"};